import { IconType } from "../../components/Icon";
import { Layout } from "../../components/Layout";
import { Navbar } from "../../components/Navbar";
import { NavigationBackground, NavigationTitle } from "../../components/NavigationTitle";
import { ChangeLanguage } from "../../components/PagesContent/ChangeLanguage";

export const ChangeLanguagePage = () => {
  const topBar = (
    <NavigationTitle
      background={NavigationBackground.inherit}
      includeDivider={true}
      title="language"
      iconName="arrowLeft"
      iconType={IconType.default}
    />
  );
  const navBar = <Navbar />;

  return (
    <Layout topBar={topBar} navBar={navBar} includeGaps={false} fixedTop={false}>
      <ChangeLanguage />
    </Layout>
  );
};
